(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("ngx-subscribe", [], factory);
	else if(typeof exports === 'object')
		exports["ngx-subscribe"] = factory();
	else
		root["ngx-subscribe"] = factory();
})(this, function() {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(1);


/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var subscribe_1 = __webpack_require__(2);
exports.Subscribe = subscribe_1.Subscribe;


/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
function setValue(shadow, prop, value) {
    if (!shadow.__value)
        shadow.__value = {};
    if (shadow.__value[prop] !== value) {
        shadow.__value[prop] = value;
        if (shadow.changeDetector)
            shadow.changeDetector.markForCheck();
    }
}
function isFunction(obj) {
    return !!(obj && obj.constructor && obj.call && obj.apply);
}
function getValue(shadow, prop, defaultValue) {
    if (!shadow.__value) {
        return isFunction(defaultValue) ? defaultValue() : defaultValue;
    }
    return shadow.__value[prop];
}
function subscribe(shadow, prop, obs) {
    if (!shadow.__subs)
        shadow.__subs = {};
    shadow.__subs[prop] = obs.subscribe(function (value) { return setValue(shadow, prop, value); });
}
function unsubscribe(shadow, prop) {
    if (!shadow.__subs)
        return;
    var sub = shadow.__subs[prop];
    if (sub) {
        sub.unsubscribe();
        delete shadow.__subs[prop];
    }
}
function unsubscribeAll() {
    var self = this;
    if (!self.__subs)
        return;
    for (var _i = 0, _a = Object.getOwnPropertyNames(self.__subs); _i < _a.length; _i++) {
        var prop = _a[_i];
        self.__subs[prop].unsubscribe();
    }
}
function onDestroy() {
    var self = this;
    if (self.__ngOnDestroy)
        self.__ngOnDestroy();
    self.__unsubscribeAll();
}
function likeObservable(maybeObservable) {
    return !!maybeObservable && typeof (maybeObservable.subscribe) === 'function';
}
/**
 * Will define property which will subscribe to the given Observable on set and will return last emited value on get.
 *
 * @param defaultValue Default value which will be used till observable will emit its value for the first time.
 */
function Subscribe(defaultValue) {
    return function (target, propertyKey) {
        var proto = target.constructor.prototype;
        if (!proto['__unsubscribeAll']) {
            var ngOnDestroy = proto['ngOnDestroy'];
            if (ngOnDestroy)
                proto['__ngOnDestroy'] = ngOnDestroy;
            proto['__unsubscribeAll'] = unsubscribeAll;
            proto['ngOnDestroy'] = onDestroy;
        }
        var desc = {
            get: function () { return getValue(this, propertyKey, defaultValue); },
            set: function (value) {
                var self = this;
                unsubscribe(self, propertyKey);
                // looks like Observable?
                if (likeObservable(value)) {
                    subscribe(self, propertyKey, value);
                }
                else {
                    setValue(self, propertyKey, value);
                }
            }
        };
        return desc;
    };
}
exports.Subscribe = Subscribe;


/***/ })
/******/ ]);
});


// WEBPACK FOOTER //
// ngx-subscribe.umd.min.js